/* DO NOT MODIFY - THIS IS AN AUTO-GENERATED FILE */
var FALLBACK_LOCALIZED_TEXT = {
  "chat.inputLabel": "Type a message",
  "chat.sendMessageButtonLabel": "Send message",
  "chat.botLabel": "Qualtrics Assist",
  "chat.userLabel": "You",
  "chat.loaderLabel": "Loading",
  "chat.cancelButtonLabel": "Cancel request",
  "chat.accessibleMessageLabel": "{{actorLabel}}. {{messageText}}",
  "chat.maxCharacterLimit": "Max character limit reached",
  "chat.inputHelperText": "Describe your request in {{max}} characters or less",
  "filePicker.single": "Choose file",
  "filePicker.multiple": "Choose files",
  "logicEditor.all": "All of the following are true",
  "logicEditor.any": "Any of the following are true",
  "logicEditor.insertConditionBelow": "Insert condition below",
  "logicEditor.insertSetBelow": "Insert condition set below",
  "logicEditor.delete": "Delete",
  "logicEditor.conditionActions": "Condition actions",
  "menu.noItemsToDisplay": "No items to display",
  "pagination": "{{currentPage}} of {{numPages}}",
  "previousPage": "Previous Page",
  "nextPage": "Next Page",
  "searchText": "Search...",
  "clearSearchInput": "Clear search input",
  "noMatchesFound": "No matches found",
  "close": "Close",
  "configPane.showPanel": "Show panel",
  "configPane.hidePanel": "Hide panel",
  "configPane.pinPanel": "Pin panel",
  "configPane.unpinPanel": "Unpin panel",
  "increment": "Increment",
  "decrement": "Decrement",
  "collapsibleSearchInput.openSearchField": "Open Search Field",
  "toolbar.showToolbar": "Show Toolbar",
  "selectOne": "Select one",
  "selectOneOrMore": "Select one or more",
  "selectedItems": "Selected items",
  "toolbar.hideToolbar": "Hide Toolbar",
  "showPanel": "Show Panel",
  "hidePanel": "Hide Panel",
  "showLabels": "Show Labels",
  "hideLabels": "Hide Labels",
  "loading": "Loading",
  "colorPickerAnchorDesc": "Open color customization menu. Current color: {{colorName}} {{colorHex}}",
  "saturation": "saturation",
  "slider2D": "2-dimensional slider",
  "saturationPercent": "saturation: {{hsvSaturation}}%",
  "valuePercent": "value: {{hsvValue}}%",
  "hue": "hue",
  "degrees": "{{hue}} degrees",
  "alpha": "opacity",
  "hex": "hex",
  "redChannel": "red channel",
  "greenChannel": "green channel",
  "blueChannel": "blue channel",
  "alphaChannel": "alpha channel",
  "palette": "color palette",
  "selectColor": "select color",
  "checked": "checked",
  "unchecked": "unchecked",
  "mixed": "mixed",
  "advancedTable.arrowKeyDescription": "To navigate between rows and cells, use the arrow keys.",
  "advancedTable.rowActionDescription": "To perform a row action, click or press enter.",
  "advancedTable.rowCheckboxDescription": "To check or uncheck a row for bulk actions, press space.",
  "advancedTable.pinColumn": "Pin column",
  "advancedTable.unpinColumn": "Unpin column",
  "advancedTable.moveColumnLeft": "Move column left",
  "advancedTable.moveColumnRight": "Move column right",
  "advancedTable.expandRow": "Expand row",
  "advancedTable.collapseRow": "Collapse row",
  "readOnly": "Read only",
  "newOptionsLoading": "New options loading.",
  "newOptionsLoaded": "New options loaded.",
  "locked": "Locked",
  "currentPage": "Current Page",
  "firstPage": "First Page",
  "lastPage": "Last Page",
  "currentPageNumber": "Current Page: {{currentPage}}",
  "currentPageNumberOf": "Current Page: {{currentPage}} of {{numPages}}",
  "rowDisplayCount": "View {{select}} per page",
  "buttonLabel": "Button"
};

export { FALLBACK_LOCALIZED_TEXT as default };
